"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var commands = require("../commands");
var ui = require("../../ui");
var selectListView = require("../../selectListView");
commands.openFileFromDisk.on(function () {
    ui.comingSoon("Open a file from the server disk");
    selectListView.selectListView.show({
        header: 'Open a file from server disk',
        data: [],
        render: function (filePath, matched) { return matched; },
        textify: function (filePath) { return filePath; },
        onSelect: function (filePath) {
            commands.doOpenOrFocusFile.emit({ filePath: filePath });
            return '';
        },
        getNewData: function (filterValue) {
            // TODO:
            return Promise.resolve([]);
        }
    });
});



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/commands/general/openFileFromServerDisk.js
 ** module id = 394
 ** module chunks = 0
 **/